import { create } from 'zustand';
import { api } from '../services/apiService';
import type { SearchResults } from '../types/search';

interface SearchState {
  query: string;
  results: SearchResults | null;
  loading: boolean;
  open: boolean;
  setQuery: (q: string) => void;
  search: () => Promise<void>;
  setOpen: (open: boolean) => void;
}

export const useSearchStore = create<SearchState>((set, get) => ({
  query: '',
  results: null,
  loading: false,
  open: false,

  setQuery: (query: string) => set({ query }),

  search: async () => {
    const q = get().query.trim();
    if (!q) {
      set({ results: null, loading: false });
      return;
    }

    set({ loading: true });
    try {
      const results = await api.get<SearchResults>(`/search?q=${encodeURIComponent(q)}`);
      set({ results, loading: false });
    } catch (err) {
      console.error('Search failed:', err);
      set({ results: null, loading: false });
    }
  },

  setOpen: (open: boolean) => {
    if (!open) {
      set({ open, query: '', results: null });
    } else {
      set({ open });
    }
  },
}));
